const configService = {
  // apiUrl: "http://localhost:3000"
  apiUrl: "https://api-dot-winged-math-301919.uk.r.appspot.com"
};

export default configService;
